import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { isLoadingType } from 'decentraland-dapps/dist/modules/loading/selectors'
import { fetchAccountMetricsRequest, FETCH_ACCOUNT_METRICS_REQUEST } from '../../../modules/account/actions'
import { getMetricsByAddress, getLoading } from '../../../modules/account/selectors'
import { RootState } from '../../../modules/reducer'
import { getAddress } from '../../../modules/wallet/selectors'
import Stats from './Stats'
import { MapStateProps, MapDispatchProps } from './Stats.types'

const getEmptyMetrics = (address: string) => ({
  address,
  earned: '0',
  spent: '0',
  royalties: '0',
  purchases: 0,
  sales: 0
})

const mapState = (state: RootState): MapStateProps => {
  const address = getAddress(state)!
  const metrics = getMetricsByAddress(state)[address]
  const emptyMetrics = getEmptyMetrics(address)
  const isLoading = isLoadingType(getLoading(state), FETCH_ACCOUNT_METRICS_REQUEST)

  return {
    address,
    totalSales: metrics?.aggregated?.sales || emptyMetrics.sales,
    totalEarnings: metrics?.aggregated?.earned || emptyMetrics.earned,
    ethereumEarned: metrics?.ETHEREUM?.earned || emptyMetrics.earned,
    maticEarned: metrics?.MATIC?.earned || emptyMetrics.earned,
    royalties: metrics?.aggregated?.royalties || emptyMetrics.royalties,
    isLoading
  }
}

const mapDispatch = (dispatch: Dispatch): MapDispatchProps => {
  return {
    onFetchMetrics: address => dispatch(fetchAccountMetricsRequest({ address: [address] }))
  }
}

export default connect(mapState, mapDispatch)(Stats)
